import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { SettingsService } from "user/settings/settings.service";

type UserSettings = stages.user.UserSettings;
type UserSettingsMetadata = stages.user.UserSettingsMetadata;

@Injectable({ providedIn: "root" })
export class UserSettingsResolver implements Resolve<DataAndInfo<UserSettings, UserSettingsMetadata>> {
	constructor(private settingsService: SettingsService) {}

	async resolve(route: ActivatedRouteSnapshot): Promise<DataAndInfo<UserSettings, UserSettingsMetadata>> {
		return this.settingsService.getSettings(route.paramMap.get("workspaceId")!, route.paramMap.get("processVersion")!);
	}
}
